/**
 * Info Extractor - Extracts product information
 */
class ShopifyInfoExtractor {
  /**
   * @param {Product} product - Product object
   * @returns {string|null} Author name
   */
  extractAuthorName(product) {
    // Try metafields first
    const authorMetafieldValue = product.metafields?.author || product.metafields?.author_name;
    if (authorMetafieldValue) return authorMetafieldValue;

    // Try tags
    if (product.tags) {
      const authorTag = product.tags.find(tag => tag.startsWith('author:'));
      if (authorTag) return authorTag.replace('author:', '').trim();
    }

    // Try vendor as fallback
    if (product.vendor && product.vendor !== 'Default Vendor') {
      return product.vendor;
    }

    return null;
  }

  /**
   * @param {string} title - Product title
   * @returns {string|null} Edition
   */
  extractEditionFromTitle(product) {
    if (!product) return null;

    const editionMatch = product.metafields?.edition;
    if (editionMatch) return editionMatch;
    
    return null;
  }

  /**
   * @param {Product} product - Product object
   * @returns {string|null} ISBN
   */
  extractISBNFromProduct(product) {
    // Try metafields
    const isbnValue = product.metafields?.isbn || product.metafields?.isbn13;
    if (isbnValue) return isbnValue;

    /*
      //FMVP-1074 - Commenting the return of a barcode as an ISBN when an ISBN cannot be found.
      // Try variants barcode
      if (product.variants) {
        const variantWithBarcode = product.variants.find(v => v.barcode);
        if (variantWithBarcode?.barcode) return variantWithBarcode.barcode;
      }
    */

    return null;
  }

  /**
   * @param {Product} product - Product object
   * @returns {string|null} Publisher name
   */
  extractPublisherName(product) {

    const publisherMetafieldValue = product.metafields?.publisher || product.metafields?.publisher_name;
    if (publisherMetafieldValue) return publisherMetafieldValue;

    return product.vendor || null;
  }

  

  /**
   * @param {Product} product - Product object
   * @returns {string|null} Publisher name
   */
  extractPublisher(product) {

    const publisherMetafieldValue = product.metafields?.publisher;
    if (publisherMetafieldValue) return publisherMetafieldValue;

    return null;
  }

  /**
   * @param {Product} product - Product object
   * @returns {string|null} Publisher name
   */
  extractFormat(product) {

    const publisherMetafieldValue = product.metafields?.follett_binding_type_name;
    if (publisherMetafieldValue) return publisherMetafieldValue;

    return null;
  }

  /**
   * @param {Product} product - Product object
   * @returns {string|null} Publisher name
   */
  extractCopyRight(product) {

    const publisherMetafieldValue = product.metafields?.copyright_year;
    if (publisherMetafieldValue) return publisherMetafieldValue;

    return null;
  }

  /**
   * @param {Product} product - Product object
   * @returns {string|null} Publisher name
   */
  extractPublication(product) {

    const publisherMetafieldValue = product.metafields?.published_date;
    if (publisherMetafieldValue) return publisherMetafieldValue;

    return null;
  }

  /**
   * @param {Product} product - Product object
   * @returns {string|null} Published date
   */
  extractPublishedDate(product) {

    const dateMetafieldValue = product.metafields?.published_date || product.metafields?.publication_date;
    if (dateMetafieldValue) return dateMetafieldValue;

    return product.created_at || null;
  }

  /**
   * @param {Product} product - Product object
   * @returns {string|null} Publisher code
   */
  extractPublisherCode(product) {
    // Check tags for publisher codes
    const publisherMetafieldValue = product.metafields?.publisher_code;
    if (publisherMetafieldValue) return publisherMetafieldValue;

    return product.id || null;
  }

  /**
   * @param {Product} product - Product object
   * @returns {string|null} MTC Title ID
   */
  extractMTCTitleId(product) {
    // Check product ID
    if (product.id) return product.id.toString();

    // Check handle
    if (product.handle) return product.handle;

    return null;
  }
}

window.ProductSystem = window.ProductSystem || {};
window.ProductSystem.ShopifyInfoExtractor = ShopifyInfoExtractor;
